<template>
  <div class="payment-info-form p-4">
    <h2 class="text-xl font-semibold mb-2">💳 Payment Information</h2>
    <hr class="mb-4" />

    <div class="bg-white border rounded shadow p-6">
      <h3 class="text-lg font-bold mb-2">🧾 Payment</h3>

      <p class="text-md font-semibold mb-4">
        Customer to Pay:
        <span class="text-green-600">£ {{ paymentAmount }}</span>
      </p>

      <div
        class="bg-green-100 p-3 rounded mb-6 flex justify-between items-center"
      >
        <div>
          <p class="font-bold text-sm mb-1">Monthly Payment</p>
          <p class="text-sm text-gray-700">
            Setup with Direct Debit or Credit Card
          </p>
        </div>
        <div class="text-lg font-bold text-right">£ {{ paymentAmount }}</div>
      </div>

      <div class="flex flex-col sm:flex-row gap-4">
        <button
          class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
          @click="sendPaymentLink"
        >
          Send Link to Customer to Complete Payment
        </button>

        <button
          class="bg-gray-300 text-gray-700 font-semibold py-2 px-4 rounded cursor-not-allowed"
          disabled
          @click="sendPaymentLink"
        >
          Check Payment Status
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentForm",
  data() {
    return {
      paymentAmount: 28.0, // You can make this dynamic by passing via props or Vuex
    };
  },
  methods: {
    sendPaymentLink() {
      alert("Payment link sent to customer.");
      this.$emit("next");
    },
  },
};
</script>

<style scoped>
button:disabled {
  opacity: 0.6;
}
</style>
